import React from 'react';
import LegalLayout from './LegalLayout';
import { Button } from '../../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import { Link } from 'react-router-dom';
import { FileText, File, RefreshCcw, Phone, Sparkles } from 'lucide-react';
import './legal.css';

const LegalHub = () => {
  const legalDocuments = [
    {
      title: 'Privacy Policy',
      description: 'Learn how we collect, use, and protect your personal information.',
      icon: <File className="h-8 w-8 text-blue-600" />,
      path: '/legal/privacy-policy',
    },
    {
      title: 'Terms & Conditions',
      description: 'The terms that govern your use of our services and website.',
      icon: <FileText className="h-8 w-8 text-indigo-600" />,
      path: '/legal/terms-conditions',
    },
    {
      title: 'Cancellation & Refund Policy',
      description: 'Our policies regarding order cancellations and refund procedures.',
      icon: <RefreshCcw className="h-8 w-8 text-emerald-600" />,
      path: '/legal/cancellation-refund',
    },
    {
      title: 'Free Demo Policy',
      description: 'What our custom website demo includes, and what happens if you subscribe.',
      icon: <Sparkles className="h-8 w-8 text-violet-600" />,
      path: '/legal/free-demo-policy',
    },
    {
      title: 'Contact Us',
      description: 'Get in touch with our support team for any concerns or questions.',
      icon: <Phone className="h-8 w-8 text-rose-600" />,
      path: '/legal/contact-us',
    },
  ];

  return (
    <LegalLayout title="Legal Documentation">
      <div className="prose max-w-none">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">Legal Documentation Center</h2>
        <p className="text-gray-600 mb-8">
          Welcome to our legal documentation center. Here you can find all the important policies and
          agreements that govern the use of our services. We are committed to transparency and
          providing you with clear information about your rights and responsibilities.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {legalDocuments.map((doc) => (
          <Card key={doc.title} className="border border-gray-100 hover:shadow-md transition-shadow">
            <CardHeader className="flex flex-row items-center gap-4 pb-2">
              {doc.icon}
              <div>
                <CardTitle>{doc.title}</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm text-gray-600 mb-4">
                {doc.description}
              </CardDescription>
              <Button asChild>
                <Link to={doc.path}>View Document</Link>
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </LegalLayout>
  );
};

export default LegalHub;
